import { createInitialEntities } from "../../utils/createInitialEntities";
import type { TAppModal, TAppModals, TModalsIds } from "../types";

export const MODAL_IDS = [
  "add_file_to_database",
  "add_function_modal",
  "add_new_bot_modal",
  "add_user_modal",
  "approved_tg_bot_modal",
  "ask_gpt_modal",
  "agent_assistants_modal",
  "attached_file_modal",
  "attached_file_to_database_modal",
  "case_specification_modal",
  "case_solution_modal",
  "case_preview_field_changes",
  "clean_spa_chat_modal",
  "create_agent_modal",
  "create_store_modal",
  "create_schema_object_modal",
  "change_chat_assistant_modal",
  "chat_with_agent_modal",
  "delete_modal",
  "image_view_modal",
  "file_transfer_modal",
  "object_manager",
  "preview_markdown_modal",
  "profile_modal",
  "chat_image_view_modal",
  "generate_prompt_modal",
  "manage_extra_app_modal",
  "meeting_info_modal",
  "restore_version_modal",
  "save_version_modal",
  "share_object_modal",
  "spa_name_change_modal",
  "sound_to_text_modal",
  "static_token_modal",
  "transfer_object",
  "transfer_case_example_alert_modal",
  "upload_file_method_modal",
  "warning_modal",
  "upload_file_method_modal",
  "select_database_modal",
] as const;

export const APP_MODALS: TAppModals = createInitialEntities(
  MODAL_IDS,
  (id: TModalsIds): TAppModal => ({
    id,
    info: null,
    isOpen: false,
    subtype: "",
  }),
);
